/*
  Softy Shapes — horizontal rail controls.

  Wires any [data-sh-prev] / [data-sh-next] buttons to the nearest
  [data-sh-rail] within the same section, scrolling by one "page" of
  visible cards. Disables arrows at each end. Idempotent, so it is
  safe under the theme editor's section re-render events.
*/
(function () {
  'use strict';

  var INIT_FLAG = 'shRailBound';

  /*
    vw units include the vertical scrollbar, so a `width: 100vw`
    full-bleed element overhangs the document by the scrollbar's
    width and creates a sideways scroll. Publishing the measured
    width lets those elements subtract it.
  */
  function measureScrollbar() {
    var w = window.innerWidth - document.documentElement.clientWidth;
    document.documentElement.style.setProperty(
      '--sh-scrollbar',
      (w > 0 ? w : 0) + 'px'
    );
  }

  measureScrollbar();
  window.addEventListener('resize', measureScrollbar);
  window.addEventListener('load', measureScrollbar);

  function pageSize(rail) {
    var first = rail.firstElementChild;
    if (!first) return rail.clientWidth;

    var styles = window.getComputedStyle(rail);
    var gap = parseFloat(styles.columnGap || styles.gap) || 0;
    var step = first.getBoundingClientRect().width + gap;

    // Scroll by whole cards, at least one, never past the viewport width.
    var perPage = Math.max(1, Math.floor(rail.clientWidth / step));
    return step * perPage;
  }

  function syncArrows(rail, prev, next) {
    var max = rail.scrollWidth - rail.clientWidth - 1;
    if (prev) prev.disabled = rail.scrollLeft <= 0;
    if (next) next.disabled = rail.scrollLeft >= max;
  }

  function init(scope) {
    var rails = (scope || document).querySelectorAll('[data-sh-rail]');

    rails.forEach(function (rail) {
      if (rail.dataset[INIT_FLAG]) return;
      rail.dataset[INIT_FLAG] = 'true';

      var section = rail.closest('.shopify-section') || document;
      var prev = section.querySelector('[data-sh-prev]');
      var next = section.querySelector('[data-sh-next]');

      function scrollBy(dir) {
        rail.scrollBy({
          left: dir * pageSize(rail),
          behavior: 'smooth',
        });
      }

      if (prev) prev.addEventListener('click', function () { scrollBy(-1); });
      if (next) next.addEventListener('click', function () { scrollBy(1); });

      function sync() {
        syncArrows(rail, prev, next);
      }

      rail.addEventListener('scroll', function () {
        window.requestAnimationFrame(sync);
      }, { passive: true });

      window.addEventListener('resize', sync);

      sync();
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', function () { init(); });
  } else {
    init();
  }

  // Theme editor re-renders sections without a full page load.
  document.addEventListener('shopify:section:load', function (event) {
    init(event.target);
  });
})();
